import i18n from '@/plugins/i18n'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { type PrefixTranslationsEnum } from '@/common/types/i18n'

type ItemExtendWithName<T> = T & { name: string }

export const includeTranslationsInItems = async <T, U extends ItemExtendWithName<T> = ItemExtendWithName<T>>(
  getItems: () => Promise<T[]>,
  i18nPrefix: PrefixTranslationsEnum,
  i18nItemKey: keyof T,
) => {
  const [list] = await Promise.all([
    getItems(),
    localizationServerData.fetch({
      prefixes: i18nPrefix,
    }),
  ])

  return addNamePropertyToItems<T, U>(list, (item) => i18n.global.t(i18nPrefix + item[i18nItemKey]))
}

export const addNamePropertyToItems = <T, U extends ItemExtendWithName<T> = ItemExtendWithName<T>>(list: T[], nameGenerator: (item: T) => string) => {
  return list.map((item: T) => ({
    ...item,
    name: nameGenerator(item),
  })) as U[]
}
